module.exports = __webpack_public_path__ + "static/media/head.26997a81.svg";